import Lottie from 'lottie-react';

import loadingAnimation from './animations/billing.json';

import './loader.component.scss';

export const PaymentLoader = () => {
  return (
    <div>
      <div className="col-xs-12 col-loading co-z-100">
        <div className="box-icon">
          <div>
            <Lottie animationData={loadingAnimation} />
            <p className="text-center">
              <b>Estamos verificando tu pago. Por favor, espera un momento.</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
